import { layoutConstants } from "@constants";

export const layoutActions = {
  /**
   * 變更側邊選單開關
   * @param {boolean} collapsed - 側邊選單開關
   */
  collapsedChange: collapsed => {
    return {
      type: layoutConstants.COLLAPSED_CHANGE,
      collapsed
    };
  }
};
